import { ReactNode } from 'react';
import { DiffType } from '../constants/peerDiff';
import { getHighlightedDiffBetweenStrings } from '../../../../utils/highlighting';

export type BranchValuesType = { coreValue: string | undefined; reportedAsLabel: string | undefined; src: string | undefined };

type DiffConstructorParams = {
    peerBranchName: string;
    diffs: PropDiff[]
    diffType: DiffType;
    applyable?: boolean;
};
export class Diff {
    peerBranchName: string;
    diffs: PropDiff[]
    diffType: DiffType;
    applyable: boolean;

    constructor({
        peerBranchName, diffs, diffType, applyable = false,
    }: DiffConstructorParams) {
        this.peerBranchName = peerBranchName;
        this.diffs = diffs;
        this.diffType = diffType;
        this.applyable = applyable;
    }

    getPropDiffs() {
        return this.diffs
    }
}

type PropDiffConstructorParams = {
    prop: keyof BranchValuesType;
    peerValue: string;
    currentValue: string;
    riskLevel: number;
};

export class PropDiff {
    prop: keyof BranchValuesType;
    peerValue: string;
    applyable?: boolean;
    currentValue: string;
    diff: ReactNode[];
    riskLevel: number;
    constructor({ prop, peerValue, currentValue, riskLevel }: PropDiffConstructorParams) {
        this.prop = prop;
        this.peerValue = peerValue;
        this.currentValue = currentValue;
        this.diff = getHighlightedDiffBetweenStrings(this.peerValue, this.currentValue);
        this.riskLevel = riskLevel;
    }
}

type SpecificPropDiffConstructorParams = {
    peerValue: string;
    currentValue: string;
};

export class CoreValueDiff extends PropDiff {
    constructor({ peerValue, currentValue, riskLevel }: SpecificPropDiffConstructorParams & { riskLevel: number }) {
        super({ prop: 'coreValue', peerValue, currentValue, riskLevel });
    }
}

export class SrcDiff extends PropDiff {
    constructor({ peerValue, currentValue }: SpecificPropDiffConstructorParams) {
        super({ prop: 'src', peerValue, currentValue, riskLevel: 1 });
    }
}

export class ReportedAsLabelDiff extends PropDiff {
    constructor({ peerValue, currentValue }: SpecificPropDiffConstructorParams) {
        super({ prop: 'reportedAsLabel', peerValue, currentValue, riskLevel: 1 });
    }
}
